export default () => {
  const copyrightEles = document.querySelectorAll('.copyright-year');
  const year = new Date().getFullYear();

  if (!copyrightEles.length) return;

  copyrightEles.forEach((ele) => {
    ele.innerText = year;
  });
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/copyright.js